import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "id", "variant"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { TOAST_POSITIONS, TOAST_VARIANTS } from "../constants";
import { slideDownKeyframes, slideInKeyframes } from "../utilities";
import { BREAKPOINTS, getRem } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledToastWrapper = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isMulti', 'position'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: nowrap;\n  position: relative;\n  width: 100%;\n  z-index: ", ";\n\n  & + & {\n    margin-top: ", ";\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.size.borderRadius.large.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.zIndex.toast.value;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.medium.value;
}, function (_ref4) {
  var isMulti = _ref4.isMulti,
      position = _ref4.position,
      theme = _ref4.theme;
  return position === TOAST_POSITIONS.FIXED && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      animation-duration: ", ";\n      animation-name: ", ";\n      animation-timing-function: ", ";\n      box-shadow: ", ";\n      left: ", ";\n      position: ", ";\n      right: ", ";\n      top: ", ";\n      width: ", ";\n\n      @media ", " {\n        animation-name: ", ";\n        left: auto;\n        max-width: ", ";\n        width: 100%;\n      }\n    "])), theme.transition.duration.value, slideDownKeyframes, theme.transition.timing.value, theme.elevation[4].value, isMulti ? 'auto' : theme.size.spacing.medium.value, isMulti ? 'relative' : 'fixed', isMulti ? 'auto' : theme.size.spacing.medium.value, isMulti ? 'auto' : theme.size.spacing.medium.value, isMulti ? '100%' : 'auto', BREAKPOINTS.L, slideInKeyframes, getRem('372px'));
});
var ToastWrapper = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      id = _ref5.id,
      variant = _ref5.variant,
      other = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(StyledToastWrapper, _objectSpread(_objectSpread({
    "aria-atomic": true,
    "aria-live": "polite",
    id: id,
    ref: ref,
    role: variant === TOAST_VARIANTS.NEGATIVE ? 'alert' : null
  }, other), {}, {
    children: children
  }));
});
ToastWrapper.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,

  /** Unique identifier for component */
  id: PropTypes.string.isRequired,

  /** Specifies whether to apply multi toast styling */
  isMulti: PropTypes.bool,

  /** Sets component position accordingly to specified value */
  position: PropTypes.oneOf(Object.values(TOAST_POSITIONS)),

  /** Changes toast style depending on variant. */
  variant: PropTypes.oneOf(Object.values(TOAST_VARIANTS))
};
ToastWrapper.defaultProps = {
  isMulti: false,
  position: TOAST_POSITIONS.INLINE,
  variant: TOAST_VARIANTS.NEUTRAL
};
export { ToastWrapper };